export class SanmarPoItemVariant {

    quantity: string;
    unitPrice: string;
    size: string;
    color:string;
    unit:string;
    line:number;
   
}